import React from 'react';
import PageWrapepr from '../layout/pageWrapper';
import Hero from './Hero/Hero-section';

import Presentation from './Presentation/Presentation-section';
import Services from './Services/Services-section';
import Staff from './Staff/Staff-section';
import Testimonials from './Testimonials/Testimonials-section';
import Promo from './Promo/Promo-section';
import LastCall from './LastCall/LastCall-section';

function App() {
  return (
    <PageWrapepr footerLinkTo="#home">
      <>
        <Hero />
        <Presentation />
        <Services />
        <Staff />
        <Testimonials />
        <Promo />
        <LastCall />
      </>
    </PageWrapepr>
  );
}

export default App;
